import * as React from 'react';

import {Typography, FormControlLabel, Switch, WithStyles, withStyles} from '@material-ui/core';
import { connect } from 'react-redux';
import TranslateNew from "@translate/TranslateNew";
import CordovaContext from 'src/cordovaContext';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import * as UserActions from '@services/user/user.actions';
import {ImportCalendarStyle as styles} from './import.calendar.style';
import { runCordovaPluginCall } from '@helpers/cordovaBridge';


const tn: TranslateNew = TranslateNew.getInstance();
declare const window: any;



interface IProps  extends WithStyles<typeof styles> {
    userId: number;
    calendarSettings: ICalendarSetting;
    updateCalendarSettingsExclude: (synch: string[]) => void;
    updateCalendarSettingsSynch: (synch: boolean) => void;
}

interface IState {
    localCalendar: string[];
    deviceReady: boolean;
}

class ImportEvents extends React.Component<IProps, IState> {
    public state = {
        localCalendar:[],
        deviceReady:false
    };

    private localCalendarReady:boolean = false;

    public componentDidMount() {
        document.addEventListener("deviceready", this.handleDeviceReady, false);
        document.addEventListener("resume", this.handleLocalCalendarResume, false);
        document.addEventListener("visibilitychange", this.handleLocalCalendarVisibilityChange, false);
        if (window.plugins && window.plugins.calendar) {
            this.handleDeviceReady();
        }
    }

    public componentWillUnmount() {
        document.removeEventListener("deviceready", this.handleDeviceReady, false);
        document.removeEventListener("resume", this.handleLocalCalendarResume, false);
        document.removeEventListener("visibilitychange", this.handleLocalCalendarVisibilityChange, false);
    }

    public componentDidUpdate(oldProps:IProps) {
        if (oldProps.calendarSettings !== this.props.calendarSettings && (this.state.deviceReady || this.localCalendarReady)) {
          this.loadLocalEvents();
        }
    }
    
    public render() {

        return (
            <div style={{ display: 'grid', gridGap: '10px', padding: '12px' }}>
                <CordovaContext.Consumer>
                    {(cordovaApp) => {
                        if (cordovaApp) {
                            return (<>
                                <Typography color="textSecondary" gutterBottom={true} style={{fontSize:'12px', lineHeight: '12px'}}>
                                    {tn.lang.settingsImportInfo}
                                </Typography>
                                <div className={this.props.classes.accountItem} >
                                <FormControlLabel 
                                    onClick={(event:any) => 
                                    this.props.updateCalendarSettingsSynch(this.props.calendarSettings.synchCalendar?false:true)}
                                    control={<Switch color="primary" checked={(this.props.calendarSettings.synchCalendar?true:false)}/>} 
                                    label={tn.lang.import} />
                                </div>
                                {
                                this.props.calendarSettings.synchCalendar && this.state.localCalendar.map((calName:string) => 
                                    <div className={this.props.classes.accountItem} key={calName} 
                                    style={{marginLeft:30, marginTop:-24}}>
                                    <FormControlLabel 
                                        onClick={(event:any) => this.updateCalendarSettingsExclude(calName)}
                                        disabled={this.props.calendarSettings.excludeCalendar === undefined}
                                        control={<Switch color="primary" checked={(this.props.calendarSettings.excludeCalendar 
                                        && !this.props.calendarSettings.excludeCalendar.includes(calName))}/>} 
                                        label={calName} />
                                    </div>)
                                }</>);
                        } else {
                            return (<Typography color="textSecondary" gutterBottom={true}>
                                {tn.lang.settingsImportComputer}
                            </Typography>);
                        }
                    }}
                </CordovaContext.Consumer>
            </div>
        );
    }

    private updateCalendarSettingsExclude(calName: string) {
        const currentCalendar = this.props.calendarSettings.excludeCalendar
            ? [...this.props.calendarSettings.excludeCalendar]
            : [];
        const index = currentCalendar.indexOf(calName);
        if (index > -1) {
            currentCalendar.splice(index, 1);
        } else {
            currentCalendar.push(calName);
        }
        this.props.updateCalendarSettingsExclude(currentCalendar);
    }

    private handleDeviceReady = () => {
        if (!this.localCalendarReady) {
            this.localCalendarReady = true;
            this.setState({ deviceReady: true });
            this.loadLocalEvents();
            return;
        }

        this.loadLocalEvents();
    }

    private handleLocalCalendarResume = () => {
        if (this.localCalendarReady || this.state.deviceReady) {
            this.loadLocalEvents();
        }
    }

    private handleLocalCalendarVisibilityChange = () => {
        if (!document.hidden) {
            this.handleLocalCalendarResume();
        }
    }

    private loadLocalEvents() {
        if ((this.state.deviceReady || this.localCalendarReady) && window.plugins && window.plugins.calendar && this.props.calendarSettings
            && this.props.calendarSettings.synchCalendar === true) {
            const didStart = runCordovaPluginCall("Calendar.listCalendars", () => {
                window.plugins.calendar.listCalendars((data: any[]) => {
                    const newList: string[] = [];
                    data.forEach((calendar: any) => {
                        if (calendar && calendar.name && !newList.includes(calendar.name)) {
                            newList.push(calendar.name);
                        }
                    });
                    this.setState({ localCalendar: newList });
                }, (error: any) => { console.log(error, 'error'); });
                return true;
            }, false);
            if (!didStart) {
                this.setState({ localCalendar: [] });
            }
        } else {
            const newList: string[] = [];
            this.setState({ localCalendar: newList })
        }
    }
}

function mapStateToProps(state: any) {
    const userId = state.user.session.data.id;

    return {
        userId,
        calendarSettings: state.user.calendarSettings,
      };
}

const mapDispatchToProps = {
    updateCalendarSettingsSynch:UserActions.updateCalendarSettingsSynch,
    updateCalendarSettingsExclude:UserActions.updateCalendarSettingsExclude,
};





export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ImportEvents));



// WEBPACK FOOTER //
// ./src/components/calendar-export/import.calendar.tsx